import { Component, OnInit, Signal, signal } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { HouseInsuranceLeadModel } from '../../../../../../shared/store/lead/types';
import { LeadService } from '../../../../../../shared/store/lead/lead.service';
import {
  ControlContainer,
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { take } from 'rxjs/operators';
import { Entity } from '../../../../../../shared/store/view/types';
import {
  DataType,
  DropdownStyle,
} from '../../../../../../shared/store/typeahead/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  removeValidators,
  setValidators,
} from '../../../../../../shared/helper/formhelper';

@UntilDestroy()
@Component({
  selector: 'app-lead-form-house',
  templateUrl: './lead-form-house.component.html',
  styleUrls: ['./lead-form-house.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  standalone: false,
})
export class LeadFormHouseComponent implements OnInit {
  houseDetail$: Observable<HouseInsuranceLeadModel>;
  leadForm: FormGroup<any>;

  isFlat = signal<boolean>(false);

  protected readonly Entity = Entity;
  protected readonly DropdownStyle = DropdownStyle;
  protected readonly DataType = DataType;

  constructor(
    private readonly leadService: LeadService,
    private parent: FormGroupDirective,
    private formBuilder: FormBuilder,
  ) {
    this.houseDetail$ = this.leadService.getHouseDetail.value$;
  }

  ngOnInit(): void {
    this.leadForm = this.parent.form;

    this.leadForm.addControl(
      'houseFormGroup',
      this.formBuilder.group({
        houseHousingType: [undefined, [Validators.required]],
        houseFlatLevel: [undefined],
        houseNbOfRooms: [1],
        houseAmountToInsure: [undefined, [Validators.required]],
        houseAddress: ['', [Validators.required]],
        houseZipCode: [
          '',
          [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5),
          ],
        ],
        houseCity: [undefined, [Validators.required]],
        houseResidencyType: [undefined, [Validators.required]],
        houseArea: [1, [Validators.required]],
        houseConstructionType: [undefined, [Validators.required]],
        houseRoofType: [undefined, [Validators.required]],
        houseOccupancyRole: [undefined],
        houseCurrentInsuranceCompany: [undefined],
        houseFireCoverage: [false],
        houseWaterCoverage: [false],
        houseTheftCoverage: [false],
        houseGlassBreakCoverage: [false],
        housePublicLiabilityCoverage: [false],
        houseFeeCancellationCoverage: [false],
        housePoolCoverage: [false],
        houseDogCoverage: [false],
        houseElectricalDamageCoverage: [false],
        profession: [''],
        maritalStatus: [''],
      }),
    );

    this.houseDetail$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.leadForm.patchValue({
          houseFormGroup: {
            houseHousingType: x.housingType,
            houseNbOfRooms: x.nbOfRooms,
            houseAmountToInsure: x.amountToInsure,
            houseAddress: x.address,
            houseZipCode: x.zipCode,
            houseCity: x.city,
            houseFlatLevel: x.flatLevel,
            houseResidencyType: x.residencyType,
            houseArea: x.area,
            houseConstructionType: x.constructionType,
            houseRoofType: x.roofType,
            houseOccupancyRole: x.occupancyRole,
            houseCurrentInsuranceCompany: x.currentInsuranceCompany,
            houseFireCoverage: x.fireCoverage,
            houseWaterCoverage: x.waterCoverage,
            houseTheftCoverage: x.theftCoverage,
            houseGlassBreakCoverage: x.glassBreakCoverage,
            housePublicLiabilityCoverage: x.publicLiabilityCoverage,
            houseFeeCancellationCoverage: x.feeCancellationCoverage,
            housePoolCoverage: x.poolCoverage,
            houseDogCoverage: x.dogCoverage,
            houseElectricalDamageCoverage: x.electricalDamageCoverage,
            profession: x.profession,
            maritalStatus: x.maritalStatus,
          },
        });
      });

    this.leadForm.controls['houseFormGroup']
      .get('houseHousingType')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe((value) => {
        if (value === 'Appartement') {
          this.isFlat.set(true);

          setValidators(
            this.leadForm.controls['houseFormGroup'].get('houseFlatLevel'),
            Validators.required,
          );
        } else {
          this.isFlat.set(false);

          this.leadForm.controls['houseFormGroup']
            .get('houseFlatLevel')
            ?.setValue(undefined);

          removeValidators(
            this.leadForm.controls['houseFormGroup'].get('houseFlatLevel'),
            Validators.required,
          );
        }
      });
  }
}
